export default __webpack_public_path__ + "static/lead-new-d40b4e3cec19752a035df94a3ad2a5ad.png";